import dayjs from 'dayjs'

const NO_PLASTIC_CARD_BY_NAME = [
  'Discover Scuba Diving',
  'PADI Seal Team',
  'PADI Master Seal Team',
  'Tec',
  'Public Safety',
  'Care for Children w/AED',
  'EFR Public',
  'Midway',
  'PADI Discover Mermaid',
  'PADI Basic Mermaid',
  'PADI Mermaid',
  'PADI Advanced Mermaid',
  'Care For Children Trainer',
  'ClownFish ID',
  'PADI Dolphin AWARE',
  'Dolphin Conservation',
  'PADI Mobulidae AWARE',
  'Mobulidae Conservation',
  'TURTLE AWARE-FREE DIVER',
  'Turtle Protection Freediver',
  'TURTLE AWARE Distinctive Specialty',
  'Turtle Protection Distinctive',
  'SEAHORSE DIVER',
  'Seahorse Conservation',
  'Cleanup of COT Starfish',
  'COT Starfish Cleanup',
  'U/W Surveying and Mapping',
  'Inflatable Dinghy Diving',
  'Youcan Robot U/W',
  'Freshwater Jellyfish',
  'Mermaid Performance',
  'AUA Underwater Dance',
  'AUA Advanced Underwater Dance',
]
export const hasPlasticCard = (name) => {
  return !NO_PLASTIC_CARD_BY_NAME.find((n) => name.indexOf(n) >= 0)
}

export const allEcards = ({ certifications = [], credentials = [] } = {}) =>
  certifications.concat(credentials).sort((c1, c2) => dayjs(c2.issueDate).diff(dayjs(c1.issueDate)))

export const isCert = (c) => !!c.certificationNumber
export const isCred = (c) => !isCert(c)
const isFd = (c) => isCert(c) && c.ecardName.indexOf('Freediver') >= 0
const isFdCred = (c) => isCred(c) && c.ecardName.indexOf('Freediver') >= 0
export const isFdCert = (c) => isFd(c) || isFdCred(c)
export const isEfr = (c) => c.ecardName.indexOf('EFR') === 0 || c.ecardName.indexOf('Care ') === 0
export const isMermaidPerformancerInstructor = (c) => [5245, 12985, 12986].indexOf(c.credentialNumber) >= 0
export const isMermaidPerformancer = (c) => 5245 === c.certificationNumber
const isMermaidCert = (c) => [4992, 4995, 4996, 4997].indexOf(c.certificationNumber) >= 0
const isDiscoverMermaidCert = (c) => [4992].indexOf(c.certificationNumber) >= 0
const isMidwayDiverCert = (c) => [5125].indexOf(c.certificationNumber) >= 0
export const isJuniorMermaid = (c) => isMermaidCert(c) && c?.cardTextDTOS[0]?.cardTextLine.indexOf('Junior') > -1
const isMermaidCred = (c) => [12485, 12487, 12488].indexOf(c.credentialNumber) >= 0
const isMidwayDiverCred = (c) => [12745, 12746].indexOf(c.credentialNumber) >= 0
export const isMermaid = (c) =>
  isDiscoverMermaidCert(c) ||
  isMermaidCred(c) ||
  isMermaidPerformancer(c) ||
  isMermaidPerformancerInstructor(c) ||
  isMermaidCert(c)
export const isMidwayDiver = (c) => isMidwayDiverCert(c) || isMidwayDiverCred(c)
export const isAUAUDCert = (c) => [5503, 5504].indexOf(c.certificationNumber) >= 0
export const isAUAUDCred = (c) => [13497, 13498, 13499, 13500].indexOf(c.credentialNumber) >= 0
export const isAUAUDElfCert = (c) => [5679].indexOf(c.certificationNumber) >= 0
export const isAUAUDElfCred = (c) => [13849, 13850].indexOf(c.credentialNumber) >= 0
